import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { CurriculumTreeInterface } from '../+models';

export const CURRICULUM_TREE_SERVICE_TOKEN = new InjectionToken('CurriculumTreeServiceInterface');

export interface CurriculumTreeServiceInterface {
  getAllForUser(userId: number): Observable<CurriculumTreeInterface[]>;
}
